export default "__VITE_ASSET__867cd128__"